import { gql } from "@grandvisionhq/graphql";
import BillingAddressFragment from "../../../../fragments/Profile/operations/fragments/billing-address.js";
const UPDATE_BILLING_ADDRESS = gql`
  mutation UpdateBillingAddress($customerId: ID!, $input: CustomerAddressInput!) {
    updateB2CBillingAddress(customerId: $customerId, input: $input) {
      id
      defaultBillingAddress {
        ...BillingAddressFragment
      }
    }
  }
  ${BillingAddressFragment}
`;
export {
  UPDATE_BILLING_ADDRESS as default
};
//# sourceMappingURL=update-billing-address.js.map
